// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2LFFv","amount":"Amount_amount__1W7u9","tip":"Amount_tip__UhwtX","tipHeader":"Amount_tipHeader__3P73u","tipsWrap":"Amount_tipsWrap__3P_ES"};